export default __webpack_public_path__ + "static/media/wolfram.8e854aaf.png";